export default "__VITE_ASSET__CXEwlCk2__"